import React from "react";
import Select from "../select/Select";
import { useUser } from "../../classes/contexts/UserContext";
import { TIMEZONES } from "../../classes/constants/timeZoneConstants";

export function TimezoneSwitcher({ className = "", id }) {
  const { userPreferences, updateUserTimezone } = useUser();
  const timezone = userPreferences?.display_settings?.timezone || "UTC";

  const handleSelectChange = (event) => {
    const newTimezone = event.target.value;
    if (newTimezone && newTimezone !== timezone) {
      updateUserTimezone(newTimezone);
    }
  };

  return (
    <Select
      items={TIMEZONES}
      onChange={handleSelectChange}
      selectedItem={timezone}
      className={className}
      id={id}
      aria-label="Timezone selection"
    />
  );
}

export default TimezoneSwitcher;
